import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Me ahorró semanas de trabajo. Tengo todo organizado en un solo lugar.',
  name: 'Lic. María Laura G.',
  role: 'Psicopedagoga',
  location: 'Buenos Aires',
  age: '34 años',
  initials: 'ML'
}, {
  quote: 'Las plantillas Word editables son un golazo. Las adapté a mi consultorio en minutos.',
  name: 'Lic. Soledad R.',
  role: 'Equipo de Orientación Escolar',
  location: 'Córdoba',
  age: '41 años',
  initials: 'SR'
}, {
  quote: 'Las 30 sesiones listas me salvaron. Llego preparada a cada encuentro.',
  name: 'Lic. Florencia M.',
  role: 'Psicopedagoga clínica',
  location: 'Mendoza',
  age: '29 años',
  initials: 'FM'
}, {
  quote: 'Trabajo en 3 escuelas y este kit me ordenó los legajos de todos mis pacientes.',
  name: 'Lic. Carolina D.',
  role: 'Psicopedagoga',
  location: 'Rosario',
  age: '37 años',
  initials: 'CD'
}, {
  quote: 'Material de calidad, práctico y adaptado a la realidad argentina. Lo recomiendo 100%.',
  name: 'Lic. Agustina P.',
  role: 'Equipo de Orientación',
  location: 'Tucumán',
  age: '45 años',
  initials: 'AP'
}, {
  quote: 'Lo uso tanto en consultorio como en la escuela. Las fichas de dislexia y discalculia son excelentes.',
  name: 'Lic. Romina V.',
  role: 'Psicopedagoga',
  location: 'La Plata',
  age: '33 años',
  initials: 'RV'
}];
export function TestimonialSection() {
  return <section className="py-16 md:py-24 px-4" data-id="element-123">
      <div className="max-w-6xl mx-auto" data-id="element-124">
        <h2 className="text-4xl md:text-5xl font-black text-center text-gray-900 mb-16 uppercase" data-id="element-125">
          Lo que dicen quienes ya lo usan
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-126">
          {testimonials.map((t, i) => <div key={i} className="bg-white/60 backdrop-blur-sm p-8 rounded-2xl border border-orange-100/50 shadow-sm" data-id="element-127">
              <div className="flex gap-1 mb-4" data-id="element-128">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" data-id="element-129" />)}
              </div>
              <p className="text-xl font-bold text-gray-800 mb-6 italic" data-id="element-130">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-131">
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-orange-400 to-amber-600 flex items-center justify-center text-white font-bold text-xl flex-shrink-0" data-id="element-132">
                  {t.initials}
                </div>
                <div data-id="element-133">
                  <p className="font-black text-gray-900" data-id="element-134">{t.name}</p>
                  <p className="text-sm text-gray-600 font-medium" data-id="element-135">{t.role}</p>
                  <p className="text-xs text-gray-500" data-id="element-136">
                    {t.location}, {t.age}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}